export default __webpack_public_path__ + "static/media/step2Plwd.7aa007c7.png";